/**
 * Service: coupons
 */
angular.module('acme.common.service.coupons', [])
.service('CouponsService', [function() {

    return {
      name: 'coupons',
      key: 'enableCoupons',

      init: function() {
        return true;
      }

    };

}]);